import { QuickAccessIconSource } from '../../interfaces/ui/quick-access.interface';
import { FA_ICON_PREFIX, QUICK_ACCESS_ACTION_FALLBACK_ICON } from './quick-access.constant';

export type QuickAccessIconView = { kind: 'fa'; classes: string } | { kind: 'svg'; name: string };

export function isFaIcon(icon: string | null | undefined): boolean {
  return !!icon && icon.startsWith(FA_ICON_PREFIX);
}

export function faIconClass(icon: string): string {
  return `fa fa-${icon.slice(FA_ICON_PREFIX.length)}`;
}

export function iconBareName(icon: string): string {
  return isFaIcon(icon) ? icon.slice(FA_ICON_PREFIX.length) : icon;
}

export function quickAccessIconToken(source: QuickAccessIconSource): string {
  if (source.customIcon) return source.customIcon;
  if (source.isAction) return source.groupIcon || QUICK_ACCESS_ACTION_FALLBACK_ICON;
  return source.groupIcon;
}

export function resolveQuickAccessIcon(source: QuickAccessIconSource): QuickAccessIconView {
  const token = quickAccessIconToken(source);

  return isFaIcon(token)
    ? { kind: 'fa', classes: faIconClass(token) }
    : { kind: 'svg', name: token };
}
